<app-icon class="text-24" name="dropup-list" [@rotate]="open ? 'open' : 'close'"></app-icon>
